import { get } from '@/utils/fetch'

export function getTree(data) {
  return get({
    url: 'manage/sys/org/getOrgTree',
    data
  })
}

// 根据节点ID获取路径
export function getPathById(id, catalog, callback) {
  let temppath = [];
  try {
    function getNodePath(node) {
      temppath.push(node.id);
      if (node.id == id) {
        throw ("yes!");
      }
      if (node.children && node.children.length > 0) {
        for (var i = 0; i < node.children.length; i++) {
          getNodePath(node.children[i]);
        }
        temppath.pop();
      }
      else {
        temppath.pop();
      }
    }
    getNodePath(catalog);
  }
  catch (e) {
    let result = temppath;
    callback(result);
  }
};

export function getCheckNode(id, catalog, callback) {
  let obj = {};
  try {
    function getCheckNode(node) {
      if (node.id == id) {
        obj = node;
        throw obj;
      }
      if (node.children && node.children.length > 0) {
        for (var i = 0; i < node.children.length; i++) {
          getCheckNode(node.children[i]);
        }
      }
    }
    getCheckNode(catalog);
  }
  catch (e) {
    let result = obj;
    callback(result);
  }
}





// WEBPACK FOOTER //
// ./src/api/tree.js